/*eslint-disable */
import i18next from "i18next";
export const FIELD_IDS_TO_DISPLAY_NAME = {
    firstName: i18next.t('bulk-error-column-firstName'),
    lastName: i18next.t('bulk-error-column-lastName'),
    email: i18next.t('bulk-error-column-email'),
    phone: i18next.t('bulk-error-column-phone'),
    country: i18next.t('bulk-error-column-country'),
    locale: i18next.t('bulk-error-column-locale'),
    sendActivationEmail: i18next.t('bulk-error-column-sendActivationEmail'),
    domainName: i18next.t('bulk-error-column-domainName'),
    groupIDs: i18next.t('bulk-error-column-groupIDs'),
    secondaryEmail: i18next.t('bulk-error-column-secondaryEmail'),
    preferredLanguage: i18next.t('bulk-error-column-preferredLanguage'),
}

export const FIELD_TO_COLUMN_INDEX_FOR_NEW_USER = {
    firstName: 1,
    lastName: 2,
    email: 3,
    phone: 4,
    country: 5,
    locale: 6,
    sendActivationEmail: 7,
    domainName: 8,
    groupIDs: 9,
    secondaryEmail: 10,
    preferredLanguage: 11,
};

export const FIELD_TO_COLUMN_INDEX_FOR_REACTIVATE_USER = {
    email: 1,
    domainName: 2
};

export const FIELD_IDS_TO_ERROR_MESSAGE = {
    firstName: i18next.t('bulk-error-message-firstName'),
    lastName: i18next.t('bulk-error-message-lastName'),
    email: i18next.t('bulk-error-message-email'),
    phone: i18next.t('bulk-error-message-phone'),
    country: i18next.t('bulk-error-message-country'),
    locale: i18next.t('bulk-error-message-locale'),
    sendActivationEmail: i18next.t('bulk-error-message-sendActivationEmail'),
    domainName: i18next.t('bulk-error-message-domainName'),
    groupIDs: i18next.t('bulk-error-message-groupIDs'),
    secondaryEmail: i18next.t('bulk-error-message-secondaryEmail'),
    preferredLanguage: i18next.t('bulk-error-message-preferredLanguage')
}